import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { styled, Flex } from '@streem/ui-react';
import { NetworkSignalLevel } from './network_signal_level';
import { NetworkQualitySignalText } from './network_quality_text';
import { NetworkQualityDropdown } from './network_quality_dropdown_menu';
import { NetworkSignalLevelLostConnectionText } from './network_quality_lost_connection_text';
import { useObservable } from '../../../../hooks/rxjs';
import { useRoomSession } from '../../../../context/room_session';
export const NetworkQuality = () => {
    const roomSession = useRoomSession();
    const [callStartTime] = useObservable(roomSession.bookmarks.callStartTime);
    const [showNetworkQuality, setShowNetworkQuality] = useState(false);
    useEffect(() => {
        if (!callStartTime)
            return;
        const networkQualityTimeoutId = setTimeout(() => {
            setShowNetworkQuality(true);
        }, 1000);
        return () => clearTimeout(networkQualityTimeoutId);
    }, [callStartTime]);
    return (_jsxs(_Fragment, { children: [_jsxs(NetworkQualityContainer, { children: [_jsx(NetworkSignalLevel, { showNetworkQuality: showNetworkQuality }), _jsx(NetworkQualitySignalText, {}), _jsx(NetworkQualityDropdown, { showNetworkQuality: showNetworkQuality })] }), _jsx(NetworkSignalLevelLostConnectionText, { showNetworkQuality: showNetworkQuality })] }));
};
const NetworkQualityContainer = styled(Flex)(() => ({
    alignItems: 'center',
    marginLeft: '3px',
}));
//# sourceMappingURL=network_quality.js.map